/** Presentation helpers. No PII leaves these functions to logs/telemetry. */

/**
 * Initials for an avatar fallback. Never throws on missing/empty names
 * (spec §7.5).
 */
export function initials(displayName: string | null | undefined): string {
  const name = (displayName ?? '').trim();
  if (name === '') return '?';
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return (parts[0] ?? '?').slice(0, 2).toUpperCase();
  }
  const first = parts[0]?.[0] ?? '';
  const last = parts[parts.length - 1]?.[0] ?? '';
  return `${first}${last}`.toUpperCase() || '?';
}

/**
 * Masks an email for display where masking is required (e.g. connection cards):
 * "alice@gmail.com" -> "a***@gmail.com". Returns null if no usable email.
 */
export function maskEmail(email: string | null | undefined): string | null {
  const value = (email ?? '').trim();
  const at = value.indexOf('@');
  if (at <= 0) return null;
  const local = value.slice(0, at);
  const domain = value.slice(at);
  const head = local[0] ?? '';
  return `${head}***${domain}`;
}

/** Formats an ISO date string to a locale date; returns "" on bad input. */
export function formatDate(iso: string | null | undefined, locale = 'vi-VN'): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(locale, { year: 'numeric', month: '2-digit', day: '2-digit' });
}
